import React, { createContext, useContext, ReactNode } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { useLocation } from 'react-router-dom';

interface RecaptchaContextValue {
  isEnabled: boolean;
}

interface RecaptchaContextProps {
  children: ReactNode;
}

const RecaptchaContext = createContext<RecaptchaContextValue>({ isEnabled: false });

export function RecaptchaProvider({ children }: RecaptchaContextProps) {
  const location = useLocation();
  const reCaptchaKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY;
  const enableRecaptcha = import.meta.env.VITE_ENABLE_RECAPTCHA === 'true';
  
  // Only load reCAPTCHA on login and register pages AND if explicitly enabled
  const isAuthPage = location.pathname === '/login' || location.pathname === '/register';
  const isEnabled = !!(reCaptchaKey && isAuthPage && enableRecaptcha);
  
  if (!isEnabled) {
    return (
      <RecaptchaContext.Provider value={{ isEnabled: false }}>
        {children}
      </RecaptchaContext.Provider>
    );
  }

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={reCaptchaKey}
      scriptProps={{
        async: true,
        defer: true,
        appendTo: 'head',
      }}
    >
      <RecaptchaContext.Provider value={{ isEnabled: true }}>
        {children}
      </RecaptchaContext.Provider>
    </GoogleReCaptchaProvider>
  );
}

export function useRecaptcha() {
  const context = useContext(RecaptchaContext);
  return context;
}